import React from "react";

// The icon inside a toast. It draws itself when the toast appears:
//   success  a ring and a check mark that draw in, then a burst of gold sparks
//   error    a ring and a cross that draw in, then a short shake
//   warning  a triangle that pops in and wobbles
//   info     a ring that ripples outwards, with an "i"
//   loading  a spinner
// All the motion is in toastTheme.css.
const SPARKS = [0, 1, 2, 3, 4, 5, 6, 7];

function AnimatedToastIcon({ type, isLoading }) {
  if (isLoading) {
    return <span className="glam-spinner" aria-hidden="true" />;
  }
  const kind = ["success", "error", "warning", "info"].includes(type) ? type : "info";

  return (
    <span className={`glam-ico glam-ico--${kind}`} aria-hidden="true">
      {kind === "success" && SPARKS.map((n) => <i key={n} className="glam-spark" style={{ "--a": `${n * 45}deg` }} />)}
      <svg viewBox="0 0 36 36" width="30" height="30" fill="none" strokeLinecap="round" strokeLinejoin="round">
        {kind === "warning" ? (
          <>
            <path className="glam-draw glam-tri" d="M18 5.5 32 30H4L18 5.5Z" strokeWidth="2.6" pathLength="100" />
            <path className="glam-draw glam-mark" d="M18 14v8" strokeWidth="2.8" pathLength="100" />
            <circle className="glam-dot" cx="18" cy="26" r="1.7" />
          </>
        ) : (
          <>
            <circle className="glam-draw glam-ring" cx="18" cy="18" r="14" strokeWidth="2.6" pathLength="100" />
            {kind === "success" && <path className="glam-draw glam-check" d="M11 18.5 16 23.5 25.5 13" strokeWidth="3" pathLength="100" />}
            {kind === "error" && (
              <>
                <path className="glam-draw glam-cross-a" d="M12.5 12.5 23.5 23.5" strokeWidth="3" pathLength="100" />
                <path className="glam-draw glam-cross-b" d="M23.5 12.5 12.5 23.5" strokeWidth="3" pathLength="100" />
              </>
            )}
            {kind === "info" && (
              <>
                <path className="glam-draw glam-mark" d="M18 16.5v8" strokeWidth="3" pathLength="100" />
                <circle className="glam-dot" cx="18" cy="11.5" r="1.8" />
              </>
            )}
          </>
        )}
      </svg>
    </span>
  );
}

export default AnimatedToastIcon;
